<template>
  <div>
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right" style="padding: 12px 12px 0 12px">
      <el-breadcrumb-item :to="{ path: '/Welcome' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>月份结算列表</el-breadcrumb-item>
    </el-breadcrumb>

    <!-- 卡片 -->
    <el-card class="box-card" shadow="never" style="margin-top:20px; border-radius: 8px;">
      <!-- 搜索区域 -->
      <div class="search-container" style="margin-bottom: 20px; padding: 20px; background: linear-gradient(135deg, #f5f5f5 0%, #fefefe 100%); border-radius: 8px;">
        <div class="search-title" style="margin-bottom: 15px; display: flex; align-items: center;">
          <i class="el-icon-search" style="color: #333; font-size: 18px; margin-right: 8px;"></i>
          <span style="color: #333; font-size: 16px; font-weight: 500;">高级搜索</span>
        </div>

        <el-form
                size="mini"
                :model="searchForm"
                ref="searchForRef"
                label-width="100px"
                autocomplete="on"
        >
          <el-row :gutter="20">
            <el-col :xs="24" :sm="12" :md="8" :lg="6" :xl="6">
              <el-form-item label="所属代理商" style="margin-bottom: 15px;">
                <el-input placeholder="请选择所属代理商" v-model="searchForm.proxy_name" :readonly="true" @click.native="cProxy" clearable type="text">
                  <template slot="prefix">
                    <i class="el-icon-user" style="color: #909399;"></i>
                  </template>
                  <i slot="suffix" class="el-icon-more"></i>
                </el-input>
              </el-form-item>
            </el-col>

            <el-col :xs="24" :sm="12" :md="8" :lg="6" :xl="6">
              <el-form-item label="商户编号" style="margin-bottom: 15px;">
                <el-input
                        v-model="searchForm.cusid"
                        placeholder="请输入商户编号"
                        clearable
                        type="text"
                        style="width: 100%;"
                        size="small"
                >
                  <template slot="prefix">
                    <i class="el-icon-document" style="color: #909399;"></i>
                  </template>
                </el-input>
              </el-form-item>
            </el-col>

            <el-col :xs="24" :sm="12" :md="8" :lg="6" :xl="6">
              <el-form-item label="支付通道" style="margin-bottom: 15px;">
                <el-select
                        v-model="searchForm.paysource_id"
                        placeholder="请选择支付通道"
                        clearable
                        style="width: 100%;"
                        size="small"
                >
                  <template slot="prefix">
                    <i class="el-icon-money" style="color: #909399;"></i>
                  </template>
                  <el-option
                          v-for="item in paysourceList"
                          :key="item.id"
                          :label="item.name"
                          :value="item.id"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>

            <el-col :xs="24" :sm="12" :md="8" :lg="6" :xl="6">
              <el-form-item label="所属平台" style="margin-bottom: 15px;">
                <el-select
                        v-model="searchForm.type"
                        placeholder="请选择所属平台"
                        clearable
                        style="width: 100%;"
                        size="small"
                >
                  <template slot="prefix">
                    <i class="el-icon-platform" style="color: #909399;"></i>
                  </template>
                  <el-option label="油税通" :value="1"></el-option>
                  <el-option label="第三方" :value="2"></el-option>
                  <el-option label="反向通" :value="3"></el-option>
                </el-select>
              </el-form-item>
            </el-col>

            <el-col :xs="24" :sm="12" :md="8" :lg="6" :xl="6">
              <el-form-item label="月份" style="margin-bottom: 15px;">
                <el-date-picker
                        v-model="searchForm.month"
                        type="month"
                        placeholder="选择月份"
                        value-format="yyyy-MM"
                        clearable
                        style="width: 100%;"
                        size="small"
                >
                </el-date-picker>
              </el-form-item>
            </el-col>

            <el-col :xs="24" :sm="12" :md="8" :lg="6" :xl="6">
              <el-form-item label="类别" style="margin-bottom: 15px;">
                <el-select
                        v-model="searchForm.grade_id"
                        placeholder="请选择类别"
                        clearable
                        style="width: 100%;"
                        size="small"
                >
                  <template slot="prefix">
                    <i class="el-icon-s-grid" style="color: #909399;"></i>
                  </template>
                  <el-option
                          v-for="item in gradeList"
                          :key="item.id"
                          :label="item.name"
                          :value="item.id"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>

          <div style="text-align: center; margin-top: 10px; width: 100%;">
            <el-button
                    type="primary"
                    size="small"
                    @click="searchSubmit()"
                    style="width: 120px; background: linear-gradient(135deg, #667eea 0%, #764ba2 100%); border: none;"
            >
              <i class="el-icon-search"></i> 搜索
            </el-button>
            <el-button
                    type="default"
                    size="small"
                    @click="resetSearch()"
                    style="width: 120px; margin-left: 10px;"
                    plain
            >
              <i class="el-icon-refresh"></i> 重置
            </el-button>
          </div>
        </el-form>
      </div>

      <!-- 紧凑型单色背景统计信息卡片 -->
      <div class="compact-statistics" style="margin-bottom: 25px;">
        <el-row :gutter="16">
          <!-- 第一行：基本统计 -->
          <el-col :xs="12" :sm="6" :md="3" :lg="3">
            <div class="compact-stat-card" style="background: #fff; padding: 16px; border-radius: 6px; border: 1px solid #e4e7ed; text-align: center; height: 100px; display: flex; flex-direction: column; justify-content: center;">
              <div style="margin-bottom: 8px;">
                <i class="el-icon-document" style="font-size: 22px; color: #409EFF;"></i>
              </div>
              <div style="font-size: 20px; font-weight: bold; color: #303133; margin-bottom: 4px;">
                {{ statistics.total_count }}
              </div>
              <div style="font-size: 13px; color: #909399;">总记录数</div>
            </div>
          </el-col>

          <el-col :xs="12" :sm="6" :md="3" :lg="3">
            <div class="compact-stat-card" style="background: #fff; padding: 16px; border-radius: 6px; border: 1px solid #e4e7ed; text-align: center; height: 100px; display: flex; flex-direction: column; justify-content: center;">
              <div style="margin-bottom: 8px;">
                <i class="el-icon-money" style="font-size: 22px; color: #E6A23C;"></i>
              </div>
              <div style="font-size: 20px; font-weight: bold; color: #303133; margin-bottom: 4px;">
                ¥ {{ statistics.total_sum_balance }}
              </div>
              <div style="font-size: 13px; color: #909399;">结算总额</div>
            </div>
          </el-col>

          <el-col :xs="12" :sm="6" :md="3" :lg="3">
            <div class="compact-stat-card" style="background: #fff; padding: 16px; border-radius: 6px; border: 1px solid #e4e7ed; text-align: center; height: 100px; display: flex; flex-direction: column; justify-content: center;">
              <div style="margin-bottom: 8px;">
                <i class="el-icon-success" style="font-size: 22px; color: #67C23A;"></i>
              </div>
              <div style="font-size: 20px; font-weight: bold; color: #303133; margin-bottom: 4px;">
                ¥ {{ statistics.total_balance }}
              </div>
              <div style="font-size: 13px; color: #909399;">实际结算总额</div>
            </div>
          </el-col>

          <el-col :xs="12" :sm="6" :md="3" :lg="3">
            <div class="compact-stat-card" style="background: #fff; padding: 16px; border-radius: 6px; border: 1px solid #e4e7ed; text-align: center; height: 100px; display: flex; flex-direction: column; justify-content: center;">
              <div style="margin-bottom: 8px;">
                <i class="el-icon-check" style="font-size: 22px; color: #F56C6C;"></i>
              </div>
              <div style="font-size: 20px; font-weight: bold; color: #303133; margin-bottom: 4px;">
                {{ statistics.settled_count }}
              </div>
              <div style="font-size: 13px; color: #909399;">已结算记录</div>
            </div>
          </el-col>

          <!-- 第二行：新增的提现统计 -->
          <el-col :xs="12" :sm="6" :md="3" :lg="3">
            <div class="compact-stat-card" style="background: #fff; padding: 16px; border-radius: 6px; border: 1px solid #e4e7ed; text-align: center; height: 100px; display: flex; flex-direction: column; justify-content: center;">
              <div style="margin-bottom: 8px;">
                <i class="el-icon-circle-check" style="font-size: 22px; color: #8B5CF6;"></i>
              </div>
              <div style="font-size: 20px; font-weight: bold; color: #303133; margin-bottom: 4px;">
                ¥ {{ statistics.withdraw_apply_amount || '0.00' }}
              </div>
              <div style="font-size: 13px; color: #909399;">提现申请总额</div>
            </div>
          </el-col>

          <el-col :xs="12" :sm="6" :md="3" :lg="3">
            <div class="compact-stat-card" style="background: #fff; padding: 16px; border-radius: 6px; border: 1px solid #e4e7ed; text-align: center; height: 100px; display: flex; flex-direction: column; justify-content: center;">
              <div style="margin-bottom: 8px;">
                <i class="el-icon-circle-check" style="font-size: 22px; color: #06B6D4;"></i>
              </div>
              <div style="font-size: 20px; font-weight: bold; color: #303133; margin-bottom: 4px;">
                ¥ {{ statistics.withdraw_amount || '0.00' }}
              </div>
              <div style="font-size: 13px; color: #909399;">已提现总额</div>
            </div>
          </el-col>

          <el-col :xs="12" :sm="6" :md="3" :lg="3">
            <div class="compact-stat-card" style="background: #fff; padding: 16px; border-radius: 6px; border: 1px solid #e4e7ed; text-align: center; height: 100px; display: flex; flex-direction: column; justify-content: center;">
              <div style="margin-bottom: 8px;">
                <i class="el-icon-coin" style="font-size: 22px; color: #10B981;"></i>
              </div>
              <div style="font-size: 20px; font-weight: bold; color: #303133; margin-bottom: 4px;">
                ¥ {{ (parseFloat(statistics.withdraw_apply_amount || 0) - parseFloat(statistics.withdraw_amount || 0)).toFixed(2) }}
              </div>
              <div style="font-size: 13px; color: #909399;">待提现金额</div>
            </div>
          </el-col>

          <el-col :xs="12" :sm="6" :md="3" :lg="3">
            <div class="compact-stat-card" style="background: #fff; padding: 16px; border-radius: 6px; border: 1px solid #e4e7ed; text-align: center; height: 100px; display: flex; flex-direction: column; justify-content: center;">
              <div style="margin-bottom: 8px;">
                <i class="el-icon-percentage" style="font-size: 22px; color: #EC4899;"></i>
              </div>
              <div style="font-size: 20px; font-weight: bold; color: #303133; margin-bottom: 4px;">
                {{ statistics.withdraw_apply_amount > 0 ? ((parseFloat(statistics.withdraw_amount || 0) / parseFloat(statistics.withdraw_apply_amount)) * 100).toFixed(1) : '0.0' }}%
              </div>
              <div style="font-size: 13px; color: #909399;">提现完成率</div>
            </div>
          </el-col>
        </el-row>
      </div>

      <!-- 表格区域 -->
      <div class="table-container" style="background: white; padding: 20px; border-radius: 8px; box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.05);">
        <div class="table-header" style="display: flex; justify-content: space-between; align-items: center; margin-bottom: 20px;">
          <div style="display: flex; align-items: center;">
            <i class="el-icon-tickets" style="color: #409EFF; font-size: 20px; margin-right: 8px;"></i>
            <span style="font-size: 16px; font-weight: 500; color: #303133;">月份结算列表</span>
          </div>
          <div>
            <el-tag type="info" size="small">共 {{ total }} 条记录</el-tag>
          </div>
        </div>

        <el-table
                ref="multipleTable"
                :data="tableLoadData"
                size="small"
                stripe
                border
                style="width: 100%; border-radius: 4px; overflow: hidden;"
                :header-row-style="{background: '#f5f7fa', color: '#909399'}"
                :cell-style="{padding: '8px 0'}"
        >
          <el-table-column
                  :index="indexMethod"
                  type="index"
                  label="序号"
                  width="60"
                  align="center"
                  header-align="center"
          >
            <template slot-scope="scope">
              <span style="color: #909399;">{{ scope.$index + 1 }}</span>
            </template>
          </el-table-column>

          <el-table-column
                  label="所属代理"
                  width="100"
                  :show-overflow-tooltip='true'
                  align="center"
                  header-align="center"
          >
            <template slot-scope="scope">
              <el-tag v-if="scope.row.proxy" type="info" size="mini">
                {{ scope.row.proxy.real_name }}
              </el-tag>
              <span v-else style="color: #C0C4CC;">-</span>
            </template>
          </el-table-column>

          <el-table-column
                  label="商户编号"
                  width="130"
                  :show-overflow-tooltip='true'
                  align="center"
                  header-align="center"
          >
            <template slot-scope="scope">
              <span style="color: #409EFF; font-weight: 500;">{{ scope.row.cusid }}</span>
            </template>
          </el-table-column>

          <el-table-column
                  label="支付通道"
                  width="100"
                  :show-overflow-tooltip='true'
                  align="center"
                  header-align="center"
          >
            <template slot-scope="scope">
              <el-tag v-if="scope.row.paysource" type="success" size="mini">
                {{ scope.row.paysource.name }}
              </el-tag>
              <span v-else style="color: #C0C4CC;">-</span>
            </template>
          </el-table-column>

          <el-table-column
                  label="月份"
                  width="100"
                  :show-overflow-tooltip='true'
                  align="center"
                  header-align="center"
          >
            <template slot-scope="scope">
              <el-tag type="warning" size="mini">
                {{ scope.row.month }}
              </el-tag>
            </template>
          </el-table-column>

          <el-table-column
                  label="结算总额"
                  width="100"
                  :show-overflow-tooltip='true'
                  align="right"
                  header-align="center"
          >
            <template slot-scope="scope">
              <span style="color: #E6A23C; font-weight: bold;">{{ scope.row.sum_balance }}</span>
            </template>
          </el-table-column>

          <el-table-column
                  label="通道比例(%)"
                  width="110"
                  :show-overflow-tooltip='true'
                  align="center"
                  header-align="center"
          >
            <template slot-scope="scope">
              <span style="color: #67C23A;">{{ scope.row.source_rate }}</span>
            </template>
          </el-table-column>

          <el-table-column
                  label="税点比例(%)"
                  width="110"
                  :show-overflow-tooltip='true'
                  align="center"
                  header-align="center"
          >
            <template slot-scope="scope">
              <span style="color: #F56C6C;">{{ scope.row.plate_rate }}</span>
            </template>
          </el-table-column>



          <el-table-column
                  label="结算金额"
                  width="110"
                  :show-overflow-tooltip='true'
                  align="right"
                  header-align="center"
          >
            <template slot-scope="scope">
              <span style="color: #409EFF; font-weight: bold;">{{ scope.row.balance }}</span>
            </template>
          </el-table-column>

          <el-table-column
                  label="营收比例(%)"
                  width="110"
                  :show-overflow-tooltip='true'
                  align="center"
                  header-align="center"
          >
            <template slot-scope="scope">
              <span style="color: #F56C6C;">{{ scope.row.revenue_rate||0 }}</span>
            </template>
          </el-table-column>
          <el-table-column
                  label="转账金额"
                  width="110"
                  :show-overflow-tooltip='true'
                  align="right"
                  header-align="center"
          >
            <template slot-scope="scope">
              <span style="color: #409EFF; font-weight: bold;">{{ scope.row.sum_revenue||0 }}</span>
            </template>
          </el-table-column>
          <el-table-column
                  label="所属平台"
                  width="110"
                  :show-overflow-tooltip='true'
                  align="center"
                  header-align="center"
          >
            <template slot-scope="scope">
              <el-tag
                      :type="scope.row.type == 1 ? 'primary' : (scope.row.type == 2 ? 'success' : 'warning')"
                      size="mini"
              >
                {{ scope.row.type == 1 ? '油税通' : (scope.row.type == 2 ? '第三方' : '反向通') }}
              </el-tag>
            </template>
          </el-table-column>

          <el-table-column
                  label="是否结算"
                  width="100"
                  :show-overflow-tooltip='true'
                  align="center"
                  header-align="center"
          >
            <template slot-scope="scope">
              <el-tag
                      :type="scope.row.is_withdraw == 1 ? 'success' : 'info'"
                      size="mini"
                      effect="plain"
              >
                {{ scope.row.is_withdraw == 1 ? '已结算' : '未结算' }}
              </el-tag>
            </template>
          </el-table-column>

          <el-table-column
                  label="提现状态"
                  width="100"
                  align="center"
                  header-align="center"
          >
            <template slot-scope="scope">
              <el-tag
                      :type="getWithdrawStatusType(scope.row)"
                      size="mini"
                      effect="plain"
              >
                {{ getWithdrawStatusText(scope.row) }}
              </el-tag>
            </template>
          </el-table-column>

          <el-table-column
                  label="添加日期"
                  width="150"
                  :show-overflow-tooltip='true'
                  align="center"
                  header-align="center"
          >
            <template slot-scope="scope">
              <span style="color: #909399;">{{ scope.row.add_time | dateFormat }}</span>
            </template>
          </el-table-column>

          <el-table-column
                  fixed="right"
                  label="操作"
                  width="120"
                  align="center"
                  header-align="center"
          >
            <template slot-scope="scope">
              <el-button
                      type="primary"
                      size="mini"
                      @click="goMorePay(scope.row)"
                      style="padding: 5px 10px;"
              >
                <i class="el-icon-document"></i> 详情
              </el-button>
            </template>
          </el-table-column>
        </el-table>

        <!-- 分页 -->
        <div class="pagination-container" style="margin-top: 25px; display: flex; justify-content: space-between; align-items: center;">
          <div style="color: #606266; font-size: 14px;">
            显示第 {{ (pageNum - 1) * pageSize + 1 }} 到 {{ Math.min(pageNum * pageSize, total) }} 条记录，共 {{ total }} 条
          </div>
          <el-pagination
                  background
                  @size-change="handleSizeChange"
                  @current-change="handleCurrentChange"
                  :current-page="pageNum"
                  :page-sizes="[10, 20, 30, 100]"
                  :page-size="pageSize"
                  layout="sizes, prev, pager, next, jumper"
                  :total="total"
                  style="margin-top: 10px;"
          >
          </el-pagination>
        </div>
      </div>
    </el-card>

    <!-- 分润详情抽屉 -->
    <el-drawer
            title="分润详情"
            :visible.sync="drawer"
            :direction="direction"
            size="50%"
            :before-close="handleDrawerClose"
            wrapperClosable
    >
      <div style="width:90%;margin: 0 auto;">
        <el-table
                :data="detailList"
                size="small"
                stripe
                style="width: 100%; margin-top: 20px;"
        >
          <el-table-column
                  label="结算时间"
                  width="180"
          >
            <template slot-scope="scope">
              <el-tag type="info" size="mini">
                {{ monthFormat(scope.row.pay_time) }}
              </el-tag>
            </template>
          </el-table-column>
          <el-table-column
                  prop="balance"
                  label="利润"
                  width="120"
                  align="right"
          >
            <template slot-scope="scope">
              <span style="color: #67C23A; font-weight: bold;">{{ scope.row.balance }}</span>
            </template>
          </el-table-column>
          <el-table-column
                  label="支付渠道"
                  width="180"
          >
            <template slot-scope="scope">
              <span>{{ scope.row.paysource ? scope.row.paysource.name : '-' }}</span>
            </template>
          </el-table-column>
          <el-table-column
                  label="来源商户号"
                  width="180"
          >
            <template slot-scope="scope">
              <span style="color: #409EFF;">{{ scope.row.from_cusid }}</span>
            </template>
          </el-table-column>
        </el-table>
        <div class="block" style="margin-top:20px">
          <el-pagination
                  background
                  @size-change="handleSizeChange1"
                  @current-change="handleCurrentChange1"
                  :current-page="pageNum1"
                  :page-sizes="[10, 20, 30, 100]"
                  :page-size="pageSize1"
                  layout="total, sizes, prev, pager, next, jumper"
                  :total="total1"
          >
          </el-pagination>
        </div>
      </div>
    </el-drawer>
    <eProxyList
            :formData="formData2"
            :visible.sync="visible2"
            :title="title2"
            v-on:eventChoose="chooseProxy"
            :closeForm="closeForm2"
    />
  </div>
</template>

<script>
  import moment from 'moment'     //日期时间转换
  import eProxyList from "../../common/eProxyList"

  export default {
    name: "proxyBalanceMonthList",
    components: {eProxyList},
    props: {},
    data() {
      return {
        formData2:{},
        title2:'',
        visible2:false,
        statistics:{
          total_count:0,
          total_sum_balance:'0.00',
          total_balance:'0.00',
          settled_count:0,
          withdraw_apply_amount: '0.00', // 提现申请总额
          withdraw_amount: '0.00', // 已提现总额
        },

        detailList:[],
        drawer:false,
        direction: 'rtl',

        formData: {},
        title: "",
        visible: false,

        title1: "",
        visible1: false,

        gradeList:[],
        paysourceList: [], // 支付通道列表

        // 搜索
        searchForm: {
          proxy_name: "",
          proxy_id: "",
          cusid: "",
          paysource_id: "",
          type: "",
          month: "",
          grade_id: "",
        },

        // 数据
        tableLoadData: [],
        pageNum:1,// 当前页码
        pageSize:10,// 每页大小
        total:0,//总条目数

        pageNum1:1,// 当前页码
        pageSize1:10,// 每页大小
        total1:0,//总条目数

        showType: '',
      };
    },
    created() {
      this.showType = this.$route.query.showType;
      this.DataList();
      this.departData();
      this.getPaysourceList(); // 获取支付通道列表
    },
    filters: {
      //时间格式化
      dateFormat(add_time) {
        if (add_time == undefined) {
          return "";
        }
        return moment(add_time*1000).format("YYYY-MM-DD HH:mm:ss");
      },
    },
    methods: {
      // 获取提现状态标签类型
      getWithdrawStatusType(row) {
        // 这里假设有withdraw_status字段，1=已提现，0=未提现，2=提现中
        if (row.withdraw_status === 1) {
          return 'success';
        } else if (row.withdraw_status === 0) {
          return 'warning';
        } else if (row.withdraw_status === 2) {
          return 'primary';
        } else {
          return 'info';
        }
      },

      // 获取提现状态文本
      getWithdrawStatusText(row) {
        if (row.withdraw_status === 1) {
          return '已提现';
        } else if (row.withdraw_status === 0) {
          return '未提现';
        } else if (row.withdraw_status === 2) {
          return '提现中';
        } else {
          return '未知';
        }
      },

      chooseProxy(id,...params){
        this.searchForm.proxy_id=id;
        this.searchForm.proxy_name=params[0];
      },

      cProxy(){
        this.title2="选择所属代理";
        this.visible2=true;
      },

      closeForm2(){
        this.visible2=false;
      },

      // 获取支付通道列表
      getPaysourceList() {
        const param = {
          company_id: sessionStorage.getItem('company_id'),
          access_token: sessionStorage.getItem('token'),
        }
        this.$axios.findPaySourceList(param).then(res => {
          if (res.code == 200) {
            this.paysourceList = res.data;
          }
        }).catch(error => {
          console.log(error);
        });
      },

      monthFormat(add_time) {
        if (add_time == undefined) {
          return "";
        }
        return moment(add_time*1000).format("YYYY-MM");
      },

      handleDrawerClose() {
        this.drawer = false;
      },

      goMorePay() {
        this.drawer = true;
        this.DataList1();
      },

      indexMethod(index) {
        return (this.pageNum - 1) * this.pageSize + index + 1;
      },

      DataList() {
        let _this = this;
        const param = {
          company_id: sessionStorage.getItem('company_id'),
          access_token: sessionStorage.getItem('token'),
          proxy_id:_this.searchForm.proxy_id,
          pageNum: _this.pageNum,
          pageSize: _this.pageSize,
          customer_name: _this.searchForm.customer_name,
          cusid: _this.searchForm.cusid,
          paysource_id: _this.searchForm.paysource_id,
          type: _this.searchForm.type,
          month: _this.searchForm.month,
          grade_id: _this.searchForm.grade_id
        }

        // 清除空值
        Object.keys(param).forEach(key => {
          if (param[key] === '' || param[key] === null || param[key] === undefined) {
            delete param[key];
          }
        });

        this.$axios.findProxyBalanceMonthListP(param).then(res => {
          if(res.code == 200) {
            this.tableLoadData = res.data.data;
            this.total = res.data.total;

            // 计算统计数据
            this.calculateStatistics(res.data.data);
          }
        }).catch(error => {
          console.log(error);
        });
      },

      // 计算统计数据
      calculateStatistics(data) {
        let totalSumBalance = 0;
        let totalBalance = 0;
        let settledCount = 0;
        let withdrawApplyAmount = 0;
        let withdrawAmount = 0;

        data.forEach(item => {
          totalSumBalance += parseFloat(item.sum_balance || 0);
          totalBalance += parseFloat(item.balance || 0);
          if (item.is_withdraw == 1) {
            settledCount++;
          }

          // 计算提现相关数据（这里假设数据中有相关字段）
          // 如果没有相关字段，可以单独调用统计接口获取
          withdrawApplyAmount += parseFloat(item.withdraw_apply_amount || 0);
          withdrawAmount += parseFloat(item.withdraw_amount || 0);
        });

        this.statistics = {
          total_sum_balance: totalSumBalance.toFixed(2),
          total_balance: totalBalance.toFixed(2),
          total_count: data.length,
          settled_count: settledCount,
          withdraw_apply_amount: withdrawApplyAmount.toFixed(2),
          withdraw_amount: withdrawAmount.toFixed(2)
        };
      },

      // 设置每页条数
      handleSizeChange(newSize) {
        this.pageSize = newSize;
        this.DataList();
      },

      // 分页跳转
      handleCurrentChange(newPage) {
        this.pageNum = newPage;
        this.DataList();
      },

      handleSizeChange1(newSize) {
        this.pageSize1 = newSize;
        this.DataList1();
      },

      DataList1() {
        let _this = this;
        const param = {
          company_id: sessionStorage.getItem('company_id'),
          access_token: sessionStorage.getItem('token'),
          proxy_id: sessionStorage.getItem('proxy_id'),
          pageNum: _this.pageNum1,
          pageSize: _this.pageSize1,
        }
        this.$axios.findProxyBalanceDetailListP(param).then(res => {
          if(res.code == 200) {
            this.detailList = res.data.data;
            this.total1 = res.data.total;
          }
        }).catch(error => {
          console.log(error);
        });
      },

      // 分页跳转
      handleCurrentChange1(newPage) {
        this.pageNum1 = newPage;
        this.DataList1();
      },

      departData() {
        const param = {
          company_id: sessionStorage.getItem('company_id'),
          access_token: sessionStorage.getItem('token'),
        }
        this.$axios.findTree(param).then(res => {
          if(res.code == 200) {
            this.rightslist = res.data.data;
          }
        }).catch(error => {
          console.log(error);
        });
      },

      // 搜索
      searchSubmit() {
        this.pageNum = 1;
        this.DataList();
      },

      // 重置搜索
      resetSearch() {
        this.searchForm = {
          proxy_name: "",
          proxy_id: "",
          cusid: "",
          paysource_id: "",
          type: "",
          month: "",
          grade_id: ""
        };
        this.pageNum = 1;
        this.DataList();
      },
    },
  };
</script>

<style scoped>
  /* 全局样式优化 */
  .box-card {
    border: 1px solid #ebeef5;
  }

  /* 搜索区域美化 */
  .search-container {
    transition: all 0.3s ease;
  }

  .search-container:hover {
    box-shadow: 0 8px 25px rgba(0,0,0,0.15);
  }

  /* 紧凑型统计卡片美化 */
  .compact-stat-card {
    transition: all 0.2s ease;
    cursor: default;
    box-shadow: 0 2px 4px rgba(0,0,0,0.05);
  }

  .compact-stat-card:hover {
    transform: translateY(-3px);
    box-shadow: 0 4px 8px rgba(0,0,0,0.1);
    border-color: #409EFF;
  }

  /* 表格美化 */
  .el-table {
    font-size: 13px;
  }

  .el-table th {
    background-color: #fafafa !important;
    font-weight: 600;
    color: #333;
  }

  .el-table tr:hover {
    background-color: #f5f7fa !important;
  }

  /* 按钮样式优化 */
  .el-button--primary {
    transition: all 0.3s ease;
  }

  .el-button--primary:hover {
    opacity: 0.9;
    transform: translateY(-2px);
  }

  /* 分页样式优化 */
  .el-pagination.is-background .el-pager li:not(.disabled).active {
    background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
    color: white;
  }

  .el-pagination.is-background .el-pager li:not(.disabled):hover {
    color: #667eea;
  }

  /* 卡片阴影效果 */
  .el-card {
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.08);
  }

  /* 响应式调整 */
  @media screen and (max-width: 768px) {
    .search-container {
      padding: 15px;
    }

    .compact-stat-card {
      margin-bottom: 15px;
      height: 90px;
    }

    .el-table__body-wrapper {
      overflow-x: auto;
    }
  }

  @media screen and (max-width: 576px) {
    .compact-stat-card {
      height: 80px;
      padding: 12px;
    }

    .compact-stat-card div:nth-child(2) {
      font-size: 18px;
    }

    .compact-stat-card div:nth-child(3) {
      font-size: 12px;
    }
  }
</style>

<style>
  /* 全局表格样式 */
  .el-table__body tr.current-row > td {
    background-color: #ecf5ff !important;
  }

  .el-table--striped .el-table__body tr.el-table__row--striped.current-row td {
    background-color: #ecf5ff !important;
  }

  /* 抽屉样式优化 */
  .el-drawer__header {
    margin-bottom: 20px;
    padding: 20px 20px 10px;
    border-bottom: 1px solid #ebeef5;
  }

  .el-drawer__title {
    font-weight: 600;
    color: #303133;
  }

  /* 表单标签样式 */
  .el-form-item__label {
    color: #606266;
    font-weight: 500;
  }
</style>
